import { ComponentType, FC } from 'react';

import { withEmailVerified } from '@app/routes/hocs/withEmailVerified';
import { withExternalRedirect } from '@app/routes/hocs/withExternalRedirect';
import { withOnboardingRequired } from '@app/routes/hocs/withOnboardingRequired';

export const withAutoNavigation = <P extends object>(Component: ComponentType<P>): FC<P> => {
  return withExternalRedirect(withEmailVerified(withOnboardingRequired(Component)));
};
